import { Text, LinkButton } from '$components'
import { AuthRoutePath } from '../routes/public'

export function ForgotPasswordConfirmationPage() {
  return (
    <div className="flex items-center justify-center min-h-screen w-full">
      <div className="space-y-stack-roomy max-w-prose-sm">
        <Text type="h1">
          Check your email
        </Text>

        <Text className="text-fg-subtle">
          We&apos;ve sent a password reset link to your email address. Please check your inbox and follow the instructions.
        </Text>

        <LinkButton
          to={AuthRoutePath.Login}
          variant="secondary"
          size="lg"
        >
          Back to login
        </LinkButton>
      </div>
    </div>
  )
}
